import i18n from 'l10n';
import {handles, on, template,el,tagName} from "../adapters/backbone-decorators";
import GenericView from 'js/views/generic.view';
import InvoiceModel from 'js/models/invoiceinfo.model';
import Template from 'js/templates/profile.invoice.hbs';
import countriescode from 'countriescode';
import {Backbone} from "backboneAdapter";

require('interfaceAdapter');

@template(Template)
@el("#invoice-container")
@tagName('span')
class ProfileInvoiceView extends GenericView {

    constructor() {
        super();
        this.model = new InvoiceModel();
        this.model.bind("add", this.loadInvoice, this);
        this.loadInvoice();
    }

    delegateEvents(events) {
        this.cid = 'add-dialog';
        Backbone.View.prototype.delegateEvents.call(this, events);
    }

    // TODO examine if this should be in GenericView
    hide() {
        this.$el.hide();
    }

    show() {
        this.$el.show();
    }

    render() {
        var curCountry = this.model.get("country");
        var countryName = countriescode.alphaToCountry(curCountry);
        this.model.set("countryName", countryName);
        super.render();
        let display = false;
        if (countriescode.countryCodeToTaxAlpha(curCountry))
            display = true;
        $('#vat').toggle(display);
    }

    updateCallback(attributeName, value, outcome, e, settings) {
        if ($(e).hasClass("select")) {
            $(e).text(countriescode.alphaToCountry(value));
            $(e).prev("i")
                .removeClass()
                .addClass("flag-icon")
                .addClass(`flag-icon-${value.toLowerCase()}`);
        }
        return super.updateCallback(attributeName, value, outcome, e, settings);
    }

    handleUpdate(value, settings, e) {

        if ($(e).hasClass('invoice-country')) {
            if (countriescode.countryCodeToTaxAlpha(value)) {
                $('#vat').show();
            } else {
                $('#vat').hide();
            }
        }
        if (settings.type === "checkbox") {
            if ($(e).hasClass("invoiceactive")) {
                if (value) {
                    $('#invoice-info').show();
                } else {
                    $('#invoice-info').hide();
                }
            }
        }
        return super.handleUpdate(value, settings, e);
    }

    getCountries() {
        return countriescode.getCountries();
    }

    countryNameToAlpha(name) {
        return countriescode.countryNameToAlpha(name);
    }

    @handles('app.loadInvoice')
    loadInvoice() {
        var self = this;

        console.info("Fetching invoice");
        this.model.fetch().always(function (data) {
            self.render();
            if (data && data.active) {
                $('#invoice-info').show();
            }
        });
    }

    inputIsValid(e, input) {
        var message = $(e).next("span");
        message.empty();
        message.hide();
        $(input).removeClass("invalid").addClass("valid");
    }

    inputIsInvalid(e, input, maxLength) {
        var message = $(e).next("span");
        message.text(i18n.t("profile.invalidlengthinput", {countLength: maxLength}));
        message.show();
        $(input).removeClass("valid").addClass("invalid");
    }

    inputSubmit(input) {
        if (input.hasClass('valid')) {
        } else {
            return false;
        }
    }

    inputBlur(e) {
        var message = $(e).next("span");
        message.empty();
        message.hide();
    }

    @on('click #vat-submit-btn')
    validateandSaveVatNumber() {
        var self = this;
        var url = '/CampaignCloud/checkvat';
        var newVatVal = $('#newVatInput').val()
        var formValues = {
            vatNumber: newVatVal,
            country: countriescode.countryCodeToTaxAlpha(self.model.get("country"))
        };
        $.ajaxDefaultQ({
            url: url,
            type: 'GET',
            dataType: "json",
            data: formValues
        }).done(function (response) {
            console.info(response);
            if (response.status === "success") {
                if (response.message === "isValid") {
                    $('#vat-number').text(newVatVal);
                    self.cancelNewVat();
                } else {
                    var $newVatInput = $('#newVatInput');
                    $newVatInput.addClass('required-input');
                    $newVatInput.addClass('invalid-input');
                    $newVatInput.addClass('confirm-failure-input-borders');
                }
            }
        });
    }

    @on('click #newvat-button')
    newVat() {
        $('#newvat-form').show();
    }

    @on('click #vat-cancel-btn')
    cancelNewVat() {
        var $newVatInput = $('#newVatInput');
        $newVatInput.val('');
        $newVatInput.removeClass('required-input');
        $newVatInput.removeClass('invalid-input');
        $newVatInput.removeClass('confirm-failure-input-borders');
        $('#vat-submit-btn').attr('disabled', true);
        $('#newvat-form').hide();
    }

    @on('click #vat-clear-btn')
    clearNewVat() {

        var self = this;
        var url = '/CampaignCloud/checkvat';
        var formValues = {
            vatNumber: "",
            country: countriescode.countryCodeToTaxAlpha(self.model.get("country"))
        };
        $.ajaxDefaultQ({
            url: url,
            type: 'GET',
            dataType: "json",
            data: formValues
        }).done(function (response) {
            console.info(response);
            if (response.status === "success") {
                if (response.message === "isValid") {
                    $('#vat-number').text("-");
                    self.cancelNewVat();
                    console.info("success");
                } else {
                    console.info("fail");
                }
            }
        });
        $('#vat-submit-btn').attr('disabled', true);
        $('#newvat-form').hide();
    }

    @on('keyup input#newVatInput')
    checkVat() {
        var $newVatInput = $('#newVatInput');
        var vatNumber = $newVatInput.val();
        if (vatNumber.length) {
            $newVatInput.removeClass('required-input');
            $newVatInput.removeClass('invalid-input');
            $newVatInput.removeClass('confirm-failure-input-borders');
            $('#vat-submit-btn').removeAttr('disabled');
        }
    }
}

export default ProfileInvoiceView;
